/**
 * Development logger.
 *
 * A single, intentional place that talks to `console`, so call sites can report
 * diagnostics without tripping `no-console` individually. This is a sink, not a
 * logging framework: keep it to the levels the app actually uses.
 */
/* eslint-disable no-console */
export const logger = {
  log: (...args: unknown[]): void => {
    console.log(...args);
  },
  error: (...args: unknown[]): void => {
    console.error(...args);
  },
  warn: (...args: unknown[]): void => {
    console.warn(...args);
  },
};

export default logger;
